<template>
  <div class="access-control-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('aAccessControl.search.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <select-admin-community @changeCommunity="handleCommunityChange" />
        </el-col>
        <el-col :span="6">
              <el-input v-model="searchForm.machineCode" :placeholder="$t('aAccessControl.search.machineCode')"
                clearable />
            </el-col>
            <el-col :span="6">
              <el-input v-model="searchForm.machineName" :placeholder="$t('aAccessControl.search.machineName')"
                clearable />
            </el-col>
            <el-col :span="6">
              <el-input v-model="searchForm.locationName" :placeholder="$t('aAccessControl.search.locationName')"
                clearable />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="handleSearch">
                {{ $t('common.search') }}
              </el-button>
            </el-col>
          </el-row>
        </el-card>

        <el-card class="box-card" style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('aAccessControl.list.title') }}</span>
            <el-button type="primary" size="small" @click="handleAdd">
              {{ $t('aAccessControl.add.title') }}
            </el-button>
          </div>
          <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="communityName" :label="$t('aAccessControl.table.communityName')" align="center" />
            <el-table-column prop="machineName" :label="$t('aAccessControl.table.machineName')" align="center" />
            <el-table-column prop="mqttDeviceId" :label="$t('aAccessControl.form.mqttDeviceId')" align="center" />
            <el-table-column prop="direction" :label="$t('aAccessControl.table.direction')" align="center" width="80">
              <template slot-scope="scope">
                {{ scope.row.direction === '3306' ? $t('aAccessControl.direction.in') :
                  $t('aAccessControl.direction.out')
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('aAccessControl.table.locationName')" align="center">
              <template slot-scope="scope">
                {{ scope.row.floorNum || '' }}{{ scope.row.unitNum ? '-' + scope.row.unitNum : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="mqttState" :label="$t('aAccessControl.table.mqttState')" align="center" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.mqttState === '1200'" type="success" size="small">
                  {{ $t('aAccessControl.mqttState.online') }}
                </el-tag>
                <el-tag v-else-if="scope.row.mqttState === '1300'" type="danger" size="small">
                  {{ $t('aAccessControl.mqttState.offline') }}
                </el-tag>
                <el-tag v-else type="info" size="small">
                  {{ $t('aAccessControl.mqttState.unknown') }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="mqttHeartbeatTime" :label="$t('aAccessControl.table.mqttHeartbeatTime')" align="center" width="160">
              <template slot-scope="scope">
                {{ scope.row.mqttHeartbeatTime || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operation')" align="center" width="150">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEdit(scope.row)">
                  {{ $t('common.edit') }}
                </el-button>
                <el-button size="mini" @click="handleDetail(scope.row)">
                  {{ $t('common.detail') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination :current-page.sync="pagination.current" :page-sizes="[10, 20, 30, 50]"
            :page-size="pagination.size" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form ref="machineForm" :model="formData" :rules="formRules" label-width="120px">
        <el-form-item :label="$t('aAccessControl.form.machineName')" prop="machineName">
          <el-input v-model="formData.machineName" :placeholder="$t('aAccessControl.form.machineNamePlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('aAccessControl.form.mqttDeviceId')" prop="mqttDeviceId">
          <el-input v-model="formData.mqttDeviceId" :placeholder="$t('aAccessControl.form.mqttDeviceIdPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('aAccessControl.form.direction')" prop="direction">
          <el-select v-model="formData.direction" :placeholder="$t('aAccessControl.form.directionPlaceholder')" style="width: 100%">
            <el-option label="进" value="3306" />
            <el-option label="出" value="3307" />
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('aAccessControl.form.floor')">
              <el-select v-model="formData.floorId" :placeholder="$t('aAccessControl.form.floorPlaceholder')"
                style="width: 100%" @change="handleFloorChange" clearable>
                <el-option v-for="item in floorOptions" :key="item.floorId" :label="item.floorName"
                  :value="item.floorId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('aAccessControl.form.unit')">
              <el-select v-model="formData.unitId" :placeholder="$t('aAccessControl.form.unitPlaceholder')"
                style="width: 100%" clearable :disabled="!formData.floorId">
                <el-option v-for="item in unitOptions" :key="item.unitId" :label="item.unitNum"
                  :value="item.unitId" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设备详情" :visible.sync="detailVisible" width="500px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="设备名称">{{ detailData.machineName }}</el-descriptions-item>
        <el-descriptions-item label="MQTT设备SN">{{ detailData.mqttDeviceId }}</el-descriptions-item>
        <el-descriptions-item label="设备方向">{{ detailData.direction === '3306' ? '进' : '出' }}</el-descriptions-item>
        <el-descriptions-item label="小区">{{ detailData.communityName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="楼栋">{{ detailData.floorNum || '-' }}</el-descriptions-item>
        <el-descriptions-item label="单元">{{ detailData.unitNum || '-' }}</el-descriptions-item>
        <el-descriptions-item label="MQTT状态">
          <el-tag v-if="detailData.mqttState === '1200'" type="success" size="small">在线</el-tag>
          <el-tag v-else-if="detailData.mqttState === '1300'" type="danger" size="small">离线</el-tag>
          <el-tag v-else type="info" size="small">未知</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="最后心跳">{{ detailData.mqttHeartbeatTime || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备IP">{{ detailData.machineIp || '-' }}</el-descriptions-item>
        <el-descriptions-item label="设备MAC">{{ detailData.machineMac || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listAdminAccessControl, saveMachine, updateMachine } from '@/api/iot/aAccessControlApi'
import { queryFloors, queryUnits } from '@/api/room/addRoomViewApi'
import SelectAdminCommunity from '@/components/community/selectAdminCommunity'

export default {
  name: 'AAccessControlList',
  components: {
    SelectAdminCommunity
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      searchForm: {
        machineCode: '',
        machineName: '',
        locationName: '',
        communityId: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      isEdit: false,
      editMachineId: '',
      detailVisible: false,
      detailData: {},
      formData: {
        machineName: '',
        mqttDeviceId: '',
        direction: '3306',
        floorId: '',
        unitId: ''
      },
      formRules: {
        machineName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        mqttDeviceId: [{ required: true, message: '请输入MQTT设备SN', trigger: 'blur' }],
        direction: [{ required: true, message: '请选择设备方向', trigger: 'change' }]
      },
      floorOptions: [],
      unitOptions: [],
      communityNameMap: {}
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('aAccessControl.add.editTitle') : this.$t('aAccessControl.add.title')
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          ...this.searchForm,
          page: this.pagination.current,
          row: this.pagination.size
        }
        const { data, total } = await listAdminAccessControl(params)
        const communityIds = [...new Set(data.map(item => item.communityId).filter(Boolean))]
        if (communityIds.length > 0) {
          await this.loadCommunityNames(communityIds)
        }
        data.forEach(item => {
          if (!item.communityName) {
            item.communityName = this.communityNameMap[item.communityId] || '-'
          }
        })
        this.tableData = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('aAccessControl.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    handleCommunityChange(community) {
      this.searchForm.communityId = community.communityId
      if (community.name || community.communityName) {
        this.communityNameMap[community.communityId] = community.name || community.communityName
      }
      this.handleSearch()
    },
    async loadCommunityNames(communityIds) {
      const needLoad = communityIds.filter(id => !this.communityNameMap[id])
      if (needLoad.length === 0) return
      try {
        const { listAdminCommunitys } = require('@/api/iot/aAccessControlApi')
        for (const cid of needLoad) {
          try {
            const res = await listAdminCommunitys({ communityId: cid, page: 1, row: 1 })
            const list = res.data || []
            if (list.length > 0) {
              this.communityNameMap[cid] = list[0].name || ''
            }
          } catch (e) { /* ignore */ }
        }
      } catch (e) { /* ignore */ }
    },
    handleDetail(row) {
      this.detailData = row
      this.detailVisible = true
    },
    handleAdd() {
      if (!this.searchForm.communityId) {
        this.$message.warning('请先选择小区')
        return
      }
      this.isEdit = false
      this.editMachineId = ''
      this.formData = {
        machineName: '',
        mqttDeviceId: '',
        direction: '3306',
        floorId: '',
        unitId: ''
      }
      this.unitOptions = []
      this.loadFloors()
      this.dialogVisible = true
    },
    async handleEdit(row) {
      this.isEdit = true
      this.editMachineId = row.machineId
      const selectedFloorId = row.locationTypeCd || ''
      let selectedUnitId = row.locationObjId || ''
      if (selectedUnitId === selectedFloorId) {
        selectedUnitId = ''
      }
      await this.loadFloorsForEdit(selectedFloorId)
      this.formData = {
        machineName: row.machineName || '',
        mqttDeviceId: row.mqttDeviceId || '',
        direction: row.direction || '3306',
        floorId: selectedFloorId,
        unitId: selectedUnitId
      }
      this.dialogVisible = true
    },
    async loadFloors() {
      if (!this.searchForm.communityId) return
      try {
        const res = await queryFloors({ communityId: this.searchForm.communityId, page: 1, row: 300 })
        const floorData = res.apiFloorDataVoList || (res.data && res.data.apiFloorDataVoList) || []
        this.floorOptions = floorData.filter(f => f.floorNum !== '0')
      } catch (error) {
        this.floorOptions = []
      }
    },
    async loadFloorsForEdit(selectedFloorId) {
      await this.loadFloors()
      if (selectedFloorId) {
        await this.handleFloorChange(selectedFloorId)
      }
    },
    async handleFloorChange(floorId) {
      this.formData.unitId = ''
      this.unitOptions = []
      if (!floorId) return
      try {
        const res = await queryUnits({ communityId: this.searchForm.communityId, floorId: floorId, page: 1, row: 300 })
        const units = res.data || res || []
        this.unitOptions = Array.isArray(units) ? units.filter(u => u.unitNum !== '0') : []
      } catch (error) {
        this.unitOptions = []
      }
    },
    handleDialogClose() {
      this.$refs.machineForm && this.$refs.machineForm.resetFields()
    },
    async handleSubmit() {
      this.$refs.machineForm.validate(async(valid) => {
        if (!valid) return
        try {
          this.submitLoading = true
          const locationTypeCd = this.formData.unitId || this.formData.floorId
          const data = {
            machineName: this.formData.machineName,
            machineCode: this.formData.mqttDeviceId,
            mqttDeviceId: this.formData.mqttDeviceId,
            direction: this.formData.direction,
            locationTypeCd: locationTypeCd,
            floorId: this.formData.floorId,
            unitId: this.formData.unitId,
            machineTypeCd: '9999',
            typeId: '9999',
            communityId: this.searchForm.communityId,
            machineVersion: 'v300',
            authCode: 'nanyi_default',
            mqttState: '1300'
          }
          if (this.isEdit) {
            data.machineId = this.editMachineId
            await updateMachine(data)
            this.$message.success(this.$t('aAccessControl.updateSuccess'))
          } else {
            await saveMachine(data)
            this.$message.success(this.$t('aAccessControl.saveSuccess'))
          }
          this.dialogVisible = false
          this.getList()
        } catch (error) {
          this.$message.error(error.message || '操作失败')
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.access-control-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
